import React from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Modal } from "@mui/material";
import { makeStyles } from '@mui/styles';
import { Chip } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: "whitesmoke",
  },
  activeButton: {
    color: "white", // change this to the desired active color
    marginLeft: "auto", // This will push the link to the right
    textDecoration: "none", // Remove text decoration from the link
  },
  logo: {
    maxWidth: 160,
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    overflowY: "auto" /* Enable vertical scrolling */,
    maxHeight: "100vh" /* Set a maximum height to limit scrolling */,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

export const ResourceGroupModal = (props) => {
  console.log("ResourceGroupModal props: " , props);
  const columns = [
    { field: "resourcename", headerName: "Resource Group", width: 200 },
    { field: "description", headerName: "Description", width: 400 },
  ];

  const handleModalClose = () => {
    props.handleModalClose();
    props.setOpen(false);
  };
  const classes = useStyles();
  return (
    <Modal
      className={classes.modal}
      open={props.isOpen}
      onClose={handleModalClose}
    >
      <div className={classes.paper}>
        <h3>List of Resource Groups for Account {props?.accountName && (<Chip label={props?.accountName} color="primary" />)}</h3>
        
        <DataGrid
          rows={props.resourceGroups}
          columns={columns}
          pageSize={5}
          components={{
            Toolbar: GridToolbar,
          }}
          disableSelectionOnClick
          autoHeight
          disableColumnMenu
          disableColumnSelector
          getRowId={(row) => row.resourcename}
        />
      </div>
    </Modal>
  );
};
